import * as React from 'react';
import { AppContext } from '@src/context/store';
import { TextAndDisplayCard } from './text-and-display';
import { getTheme } from '@src/context/selectors/app-settings';
import { getTranslations, isAppEnabled, getKBLinks } from '@src/context/selectors/ui-settings';

export const TextAndDisplayContainer = () => {
  const state = React.useContext(AppContext);

  return (
    <TextAndDisplayCard
      theme={getTheme(state)}
      translations={getTranslations(state)}
      updatePendingAppSettings={state.updatePendingAppSettings}
      updatePendingTranslations={state.updatePendingTranslations}
      disabled={!isAppEnabled(state)}
      infoNoteLearnMoreKBLink={getKBLinks(state).DisplayCookieBannerOnSite}
    />
  );
};
